import axios from "axios";
import { useEffect, useState } from "react";
import { novedadesDTO } from "../../models/Novedades.model";
import { webApiNovedades } from "../../routes/endpoints";
import RecuadroNovedad from "./recuadro_novedad";

export default function Main(props: PropsMain) {     
    if(props.tipo===1){ localStorage.setItem("seccion", 'Recomendaciones /') } else{ localStorage.setItem('seccion','Novedades /') }
    const [novedades, setNovedades] = useState<novedadesDTO[]>();
    const {tipo} = props;

    useEffect(()=>{
        axios.post(webApiNovedades, {tipo:tipo}).then((response) => {            
            setNovedades(response.data)                              
            window.scrollTo(0, 0) 
        }).catch(err => console.warn(err));  
    },[tipo]);
    const obtieneClase = (i:number) =>{
        let claseDiv = 'col-12 col-lg-6 mt-4'
        switch (i) {
            case 0:
                 claseDiv = 'col-12 col-lg-6 mt-4 mt-lg-0'
                break;
            case 1:
                 claseDiv = 'col-12 col-lg-6 mt-4 mt-lg-0'                
                break; 
        }
        return claseDiv
    }
    if(novedades?.length){
        return(    
            <>          
                <div className="container">
                    <div className="row">
                        <div className="col-12 main_title text-center my-4">{(tipo===1)?"RECOMENDACIONES":"Novedades Editoriales"}</div>
                        { novedades?.map( (novedad, i) => <RecuadroNovedad key={i} id={ novedad.id} claseDiv={obtieneClase(i)} imagen={ novedad.imagen} titulo={ novedad.titulo} autores={ novedad.autores} colaboradores={ novedad.colaboradores} coordinadores={ novedad.coordinadores} anio={novedad.anio} tipo={tipo}/> )}
                        
                    </div>
                </div>  
                { (tipo===2) &&
                    <div className="container-fluid mt-4">
                        <div className="row">
                            <div className="col-12 divider_purple">
                            </div>
                        </div>
                    </div>
                } 
            </>          
        )
    }else{
        return(
            <div className="container-fluid mt-4 h4">Sin información</div>
        )    
    }   
}

interface PropsMain{
    tipo?:number
}

Main.defaultProps = {
    tipo: 2
}